/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SparkEngineStatus } from '../models/SparkEngineStatus';

export class SparkEngine {
  /**
  * The unique identifier of the Spark engine
  */
  'id': string;
  /**
  * The name of the Spark engine
  */
  'name': string;
  /**
  * The size of the Spark engine
  */
  'engineSize': string;
  'status': SparkEngineStatus;
  /**
  * The timestamp when the Spark engine was created
  */
  'createdAt': Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "engineSize",
      "baseName": "engineSize",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "SparkEngineStatus",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return SparkEngine.attributeTypeMap;
  }

  public constructor() {
  }
}



